// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4b-6";
export var headerCell = "_4b-2";
export var rowWrapper = "_4b-4";
export var stickyAggregationCell = "_4b-a";
export var stickyAggregationRow = "_4b-7";
export var stickyColumnCell = "_4b-9";
export var stickyColumnHeaderCell = "_4b-8";
export var table = "_4b-1";
export var virtualRowWrapper = "_4b-5";
export var virtualTableContainer = "_4b-0";
export var white = "_4b-3";